import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { Card } from '@mui/material';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PlaceIcon from '@mui/icons-material/Place';
import { DEFAULT_CAFE_IMG } from '../../../../utils/constant';

const CafeCard = styled(Card)(({ theme }) => ({
  boxSizing: 'border-box',
  // width: '295px',
  // height: '250px',
  border: '1px solid #ffff',
  background:
    'linear-gradient(250.42deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.08) 101.65%)',
  padding: '9px',
  margin: '0 10px',
  [theme.breakpoints.down('sm')]: {
    maxWidth: '300px',
    width: '90%',
    margin: '0 auto',
  },
}));

const CafeCardImageContainer = styled('div')({
  position: 'relative',
  filter: 'drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.3))',
  display: 'grid',
});

const CafeImage = styled('div')({
  gridArea: '1/-1',
  height: '154px',

  '& img': {
    width: '100%',
    height: '154px',
    objectFit: 'cover',
  },
});

const CommonStyle = makeStyles({
  root: {
    fontFamily: "'Raleway', sans-serif",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '14px',
    alignItems: 'center',
  },
});

const CafeCardTags = styled('div')({
  gridArea: '1/-1',
  alignItems: 'flex-end',
  marginBottom: '9px',
  marginLeft: '10px',
  display: 'flex',
  color: '#fff',

  '& div': {
    marginRight: '7px',
    borderRadius: '2px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '20px',
    padding: '2px 5px 4px 5px',
  },

  '& svg': {
    fontSize: '16px',
    marginRight: '4.5px',
  },
});

const CafeRate = styled('div')({
  boxSizing: 'border-box',
  fontWeight: '700',
});

const RateColor = makeStyles({
  LevelOne: {
    backgroundColor: 'rgba(120, 187, 95, 0.9)',
  },
  LevelTwo: {
    backgroundColor: 'rgba(188, 187, 96, 0.9)',
  },
  LevelThree: {
    backgroundColor: 'rgba(197, 143, 49, 0.9)',
  },
  LevelFour: {
    backgroundColor: 'red',
  },
  LevelFive: {
    backgroundColor: '#969696',
  },
});

const CafeLike = styled('div')({
  boxSizing: 'border-box',
  backgroundColor: 'rgba(170, 145, 120, 0.8)',
});

const CafePosts = styled('div')({
  boxSizing: 'border-box',
  backgroundColor: 'rgba(255, 122, 0, 0.79)',
});

const CafeCardContentContainer = styled('div')({
  width: '100%',
});

const TradingStatus = styled('div')({
  marginTop: '10px',
  display: 'flex',

  '& svg': {
    marginRight: '5px',
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '14px',
  },
});

const StatusColor = makeStyles({
  colorOpen: {
    color: '#3DC93B',
  },
  colorClosed: {
    color: '#BA0E0E',
  },
});

const CurrentStatus = styled('div')({
  marginRight: '5px',
});

const CloseTime = styled('div')({
  color: '#969696',
});

const CafeName = styled('div')({
  fontWeight: '700',
  fontSize: '14px',
  lineHeight: '16px',
  marginTop: '6px',
});

const CafeCardDivider = styled('div')({
  borderTop: '1px solid rgba(0, 0, 0, 0.54)',
  margin: '6.5px 0',
});

const CafeAddress = styled('div')({
  color: 'rgba(0, 0, 0, 0.54)',
  display: 'flex',
  height: '28px',
  alignItems: 'center',

  '& svg': {
    marginRight: '5px',
    fontSize: '16px',
  },

  '& p': {
    margin: '0',
  },
});

const CafeCardsItem = (props) => {
  const classes = CommonStyle(props);
  const statusColor = StatusColor(props);
  const rateColor = RateColor(props);

  return (
    <CafeCard elevation={3}>
      <CafeCardImageContainer>
        <CafeImage>
          <img src={props.cafe.photo || DEFAULT_CAFE_IMG} alt={props.cafe.alt}></img>
        </CafeImage>
        <CafeCardTags className={classes.root}>
          <CafeRate
            className={
              props.cafe.rate > 8.5
                ? rateColor.LevelOne
                : props.cafe.rate > 6.5
                ? rateColor.LevelTwo
                : props.cafe.rate > 5
                ? rateColor.LevelThree
                : props.cafe.rate > 0
                ? rateColor.LevelFour
                : rateColor.LevelFive
            }
          >
            <p>{props.cafe.rate}</p>
          </CafeRate>
          <CafeLike>
            <ThumbUpIcon />
            <p>{props.cafe.like}</p>
          </CafeLike>
          <CafePosts>
            <ImportContactsIcon />
            <p>{props.cafe.posts}</p>
          </CafePosts>
        </CafeCardTags>
      </CafeCardImageContainer>
      <CafeCardContentContainer className={classes.root}>
        <TradingStatus>
          <AccessTimeIcon />
          <CurrentStatus
            className={
              props.cafe.status === 'Open' ? statusColor.colorOpen : statusColor.colorClosed
            }
          >
            {props.cafe.status}
          </CurrentStatus>
          <CloseTime>{props.cafe.closeTime}</CloseTime>
        </TradingStatus>
        <CafeName>{props.cafe.cafeName}</CafeName>
        <CafeCardDivider />
        <CafeAddress>
          <PlaceIcon />
          <p>{props.cafe.cafeAddress}</p>
        </CafeAddress>
      </CafeCardContentContainer>
    </CafeCard>
  );
};

export default CafeCardsItem;
